import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee05a83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-explorer" }
const _hoisted_2 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_3 = { class: "group-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传文件", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新建文件夹", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "重命名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "移动至此", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))
const _hoisted_9 = { class: "group-1" }
const _hoisted_10 = { class: "path-bar" }
const _hoisted_11 = { class: "group-0" }
const _hoisted_12 = { class: "group-1" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "date-lines" }
const _hoisted_15 = { class: "list-item" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "item-avatar" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "file-name-line" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "status" }
const _hoisted_22 = { class: "status-text" }
const _hoisted_23 = {
  key: 0,
  class: "status-detail"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("清空")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_upload = _resolveComponent("i-upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_i_folder_add = _resolveComponent("i-folder-add")!
  const _component_i_edit_pen = _resolveComponent("i-edit-pen")!
  const _component_i_rank = _resolveComponent("i-rank")!
  const _component_i_delete = _resolveComponent("i-delete")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_i_folder = _resolveComponent("i-folder")!
  const _component_i_document = _resolveComponent("i-document")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.toolbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: _ctx.onUploadClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_i_upload)
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _createElementVNode("input", {
                  class: "hidden-input",
                  type: "file",
                  ref: "theFileInput",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onUpload && _ctx.onUpload(...args)))
                }, null, 544)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "success",
              onClick: _ctx.mkdir
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_i_folder_add)
                  ]),
                  _: 1
                }),
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _ctx.rename,
              disabled: _ctx.selectedItems.size !== 1 || !_ctx.filtered.map(x => x.FullPath).includes(_ctx.first)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_i_edit_pen)
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _ctx.move2here,
              disabled: _ctx.selectedItems.size === 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_i_rank)
                  ]),
                  _: 1
                }),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "warning",
              onClick: _ctx.deleteAll,
              disabled: _ctx.selectedItems.size === 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_i_delete)
                  ]),
                  _: 1
                }),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_button, {
              title: "刷新",
              size: "small",
              icon: "i-refresh",
              onClick: _ctx.refresh
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (c, idx) => {
          return (_openBlock(), _createBlock(_component_el_link, {
            class: "path-item",
            key: idx,
            type: "primary",
            onClick: ($event: any) => (_ctx.cd(c.path)),
            disabled: _ctx.profile.path === c.path
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(c.name), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_button_group, { size: "small" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              title: "缩略图",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.profile.view = 'icon')),
              disabled: _ctx.profile.view === 'icon',
              icon: "i-picture"
            }, null, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              title: "列表",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.profile.view = 'list')),
              disabled: _ctx.profile.view === 'list',
              icon: "i-grid"
            }, null, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              title: "详细信息",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.profile.view = 'detail')),
              disabled: _ctx.profile.view === 'detail',
              icon: "i-tickets"
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", _ctx.profile.view])
    }, [
      (_ctx.profile.view === 'detail')
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            class: "the-table",
            data: _ctx.filtered,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "Mode",
                label: "#",
                width: "40px",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_checkbox, {
                    disabled: !_ctx.selectable(scope.row),
                    modelValue: _ctx.selectedItems.has(scope.row.FullPath),
                    "onUpdate:modelValue": ($event: any) => (_ctx.toggleItemSelected(scope.row.FullPath, $event))
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Name",
                label: "文件名"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_link, {
                    onClick: ($event: any) => (_ctx.onOpenItem(scope.row))
                  }, {
                    default: _withCtx(() => [
                      (scope.row.IsDir)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "folder-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_i_folder)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            class: "folder-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_i_document)
                            ]),
                            _: 1
                          })),
                      _createElementVNode("span", {
                        class: "file-name",
                        title: scope.row.Name
                      }, _toDisplayString(scope.row.Name), 9, _hoisted_13)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Mode",
                label: "权限",
                width: "100px",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "Size",
                label: "大小",
                width: "100px",
                align: "right",
                "header-align": "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.bytesForHuman(scope.row.Size)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Size",
                label: "修改时间",
                width: "100px",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, _toDisplayString(new Date(scope.row.ModTime * 1000).toLocaleDateString()), 1),
                    _createElementVNode("div", null, _toDisplayString(new Date(scope.row.ModTime * 1000).toLocaleTimeString()), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true),
      (_ctx.profile.view === 'list')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filtered, (i) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_el_checkbox, {
                disabled: !_ctx.selectable(i),
                modelValue: _ctx.selectedItems.has(i.FullPath),
                "onUpdate:modelValue": ($event: any) => (_ctx.toggleItemSelected(i.FullPath, $event))
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_link, {
                onClick: ($event: any) => (_ctx.onOpenItem(i))
              }, {
                default: _withCtx(() => [
                  (i.IsDir)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        class: "folder-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_i_folder)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        class: "folder-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_i_document)
                        ]),
                        _: 1
                      })),
                  _createElementVNode("span", {
                    class: "file-name",
                    title: i.Name
                  }, _toDisplayString(i.Name), 9, _hoisted_16)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          }), 256))
        : _createCommentVNode("", true),
      (_ctx.profile.view === 'icon')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filtered, (i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["icon-item", { selected: _ctx.selectedItems.has(i.FullPath) }])
            }, [
              _createVNode(_component_el_checkbox, {
                disabled: !_ctx.selectable(i),
                modelValue: _ctx.selectedItems.has(i.FullPath),
                "onUpdate:modelValue": ($event: any) => (_ctx.toggleItemSelected(i.FullPath, $event))
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_17, [
                (i.IsDir)
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      class: "folder-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_i_folder)
                      ]),
                      _: 1
                    }))
                  : (_ctx.isImage(i.Name))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "thumb-image",
                        src: _ctx.imageThumb(i.FullPath)
                      }, null, 8, _hoisted_18))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 2,
                        class: "folder-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_i_document)
                        ]),
                        _: 1
                      }))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (_ctx.onOpenItem(i))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "file-name",
                      title: i.Name
                    }, _toDisplayString(i.Name), 9, _hoisted_20)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ], 2))
          }), 256))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.status), 1),
      (_ctx.selectedItems.size > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "selected-item"
              }, _toDisplayString(i), 1))
            }), 128)),
            _createVNode(_component_el_button, {
              class: "btn-clear",
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedItems.clear()))
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}